import { Group } from '@mantine/core';
import { ChartType } from '../../process-analysis.type';
import { ChartTypeToggleButton } from './chart-type-toggle-button';

type Props = {
  activeChartType: ChartType;
  onChartTypeChange: (chartType: ChartType) => void;
};

export const ChartTypeToggle = ({ activeChartType, onChartTypeChange }: Props) => {
  const isActive = (chartType: ChartType) => activeChartType === chartType;

  return (
    <Group gap={8}>
      <ChartTypeToggleButton
        chartType={ChartType.Line}
        isActive={isActive(ChartType.Line)}
        onClick={() => onChartTypeChange(ChartType.Line)}
      />
      <ChartTypeToggleButton
        chartType={ChartType.Bar}
        isActive={isActive(ChartType.Bar)}
        onClick={() => onChartTypeChange(ChartType.Bar)}
      />
    </Group>
  );
};
